import { render } from "./FreeSlotCard.vue?vue&type=template&id=17fd42f0"
import script from "./FreeSlotCard.vue?vue&type=script&lang=js"
export * from "./FreeSlotCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__